export const API_CODES = [
    'UNAUTHORIZED',
    'BAD_REQUEST',
    'NOT_FOUND',
    'FORBIDDEN',
    'SERVICE_UNAVAILABLE',
    'INTERNAL_SERVER_ERROR',
    'UNPROCESSABLE_ENTITY'
];

// Base actions
export const ADD = 'ADD';
export const CANCEL = 'CANCEL';
export const CHANGE = 'CHANGE';
export const CLEAR = 'CLEAR';
export const CLOSE = 'CLOSE';
export const DELETE = 'DELETE';
export const DISABLE = 'DISABLE';
export const DONE = 'DONE';
export const FAILED = 'FAILED';
export const FETCH_OK = 'FETCH_OK';
export const FETCH_START = 'FETCH_START';
export const HIDE = 'HIDE';
export const ENABLE = 'ENABLE';
export const INPUT = 'INPUT';
export const INPUT_KEY_VALUE = 'INPUT_KEY_VALUE';
export const DELETE_KEY_VALUE = 'DELETE_KEY_VALUE';
export const OPEN = 'OPEN';
export const OPTIONS = 'OPTIONS';
export const REFRESH = 'REFRESH';
export const RESET = 'RESET';
export const REMOVE = 'REMOVE';
export const SELECT = 'SELECT';
export const INITIALIZE = 'INITIALIZE';
export const SET = 'SET';
export const SET_CATEGORY = 'SET_CATEGORY';
export const SHOW = 'SHOW';
export const START = 'START';
export const SUB_CLOSE = 'SUB_CLOSE';
export const SUB_OPEN = 'SUB_OPEN';
export const SUB_SELECT = 'SUB_SELECT';
export const SUBMIT = 'SUBMIT';
export const SUBMIT_DONE = 'SUBMIT_DONE';
export const SUCCESS = 'SUCCESS';
export const SWITCH = 'SWITCH';
export const TOGGLE = 'TOGGLE';
export const TOGGLE_ONE = 'TOGGLE_ONE';
export const TOGGLE_ALL = 'TOGGLE_ALL';
export const UPDATE = 'UPDATE';
export const SORT = 'SORT';
export const SEARCH = 'SEARCH';
export const UPDATE_FILTER = 'UPDATE_FILTER';
export const SHOW_RECOVERY_CODES = 'SHOW_RECOVERY_CODES';
export const HIDE_RECOVERY_CODES = 'HIDE_RECOVERY_CODES';
export const TOGGLE_RECOVERY_MODE = 'TOGGLE_RECOVERY_MODE';
export const RECOVERY_LOGIN_SUCCESS = 'RECOVERY_LOGIN_SUCCESS';
export const STATUS_FETCHED = 'STATUS_FETCHED';
export const RESET_2FA_START = 'RESET_2FA_START';
export const RESET_2FA_OK = 'RESET_2FA_OK';
export const RESET_2FA_CANCEL = 'RESET_2FA_CANCEL';
